import cashinusClient from '@/_http/axiosCashinusClient';

export function startCashin(ticketId, requestedAmount, changesAccepted, cashinOfferVersion) {
    return cashinusClient.post(`/cashin/v4/${ticketId}/${cashinOfferVersion}/transaction/start`, {
        ticketId,
        requestedAmount,
        changesAccepted
    });
}

export function cancelAutoCashin(ticketId, cashinOfferVersion) {
    return cashinusClient.delete(`/cashin/v4/${ticketId}/${cashinOfferVersion}/automatic-transaction/limit`);
}

export function createAutoCashin(ticketId, amount, cashinOfferVersion) {
    return cashinusClient.put(`/cashin/v4/${ticketId}/${cashinOfferVersion}/automatic-transaction/limit`, {
        ticketId,
        amount,
        forceLimit: true
    });
}
